import React, { useEffect, useState } from 'react';
import { resetPassword } from '../api';

function ResetPassword({ onGoToLogin }) {
  const [token, setToken] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    setToken(params.get('token') || '');
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    if (!token) {
      setError('This reset link is missing a token.');
      return;
    }

    if (password.length < 8) {
      setError('Password must be at least 8 characters.');
      return;
    }

    if (password !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }

    setLoading(true);
    try {
      const result = await resetPassword(token, password);
      setDone(true);
      setMessage(result.message || 'Your password has been updated. You can sign in.');
    } catch (err) {
      setError(err.error || 'Unable to reset your password.');
    } finally {
      setLoading(false);
    }
  };

  if (!token && !done) {
    return (
      <div className="container">
        <p className="brand">My Weed Buddy</p>
        <h1>Reset password</h1>
        <div className="error">This reset link is missing a token.</div>
        <button type="button" onClick={onGoToLogin}>
          Go to sign in
        </button>
      </div>
    );
  }

  return (
    <div className="container">
      <p className="brand">My Weed Buddy</p>
      <h1>Choose a new password</h1>

      {message && <div className="success">{message}</div>}
      {error && <div className="error">{error}</div>}

      {done ? (
        <button type="button" onClick={onGoToLogin}>
          Go to sign in
        </button>
      ) : (
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="password">New password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="At least 8 characters"
              required
              minLength={8}
              autoFocus
            />
          </div>

          <div className="form-group">
            <label htmlFor="confirmPassword">Confirm new password</label>
            <input
              type="password"
              id="confirmPassword"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Re-enter your password"
              required
              minLength={8}
            />
          </div>

          <button type="submit" disabled={loading}>
            {loading ? 'Saving...' : 'Update password'}
          </button>
        </form>
      )}
    </div>
  );
}

export default ResetPassword;
